//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addressIcon from 'assets/icons/icon-address@3x.png'
import timeIcon from 'assets/icons/icon-time@3x.png'

import saleingIcon from 'assets/icons/icon-sale-ing@3x.png'
import salePaddingIcon from 'assets/icons/icon-sale-padding@3x.png'
import saleWaitIcon from 'assets/icons/icon-sale-wait@3x.png'
import saleStopIcon from 'assets/icons/icon-sale-stop@3x.png'

import QiniuImg from '../../Common/QiniuImg.vue'

export default {
  name: 'RouteCard',
  props: {
    route: {
      type: Object,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
  },
  components: {
    QiniuImg,
  },
  computed: {
    routeStatusIcon() {
      const saleStatus = {
        1: saleWaitIcon,
        2: saleingIcon,
        3: salePaddingIcon,
        4: saleStopIcon,
      }
      return saleStatus[this.route.saleStatus]
    },
  },
  data() {
    return {
      addressIcon,
      timeIcon,
      features: this.route.featureList,
    }
  },
  methods: {
    calcFeaturesWidth(features) {
      let result = features.reduce((acc, feature) => (
        // feature width = 10 + 12 * n
        acc += ((feature.name.length * 10) + 8)
      ), 0)
      // margin-left: 4px
      result += (4 * (features.length - 1))
      return result
    },
    regenerateFeatures(features, allowWidth) {
      const sliceFeatures = features.slice(0, features.length - 1)
      const sliceFeaturesWidth = this.calcFeaturesWidth(sliceFeatures)
      if (allowWidth > sliceFeaturesWidth) {
        this.features = sliceFeatures
      } else {
        // 递归调用裁剪features
        this.regenerateFeatures(sliceFeatures, allowWidth)
      }
    },
    getFeatureStyle(featureStyleType) {
      const featureStyleList = ['feature-green-1', 'feature-green-2', 'feature-grey-1', 'feature-grey-2', 'feature-orange-1', 'feature-orange-2', 'feature-grass-green-1', 'feature-grass-green-2']
      return featureStyleType <= featureStyleList.length ?
       featureStyleList[featureStyleType - 1] : featureStyleList[0]
    },
  },
  ready() {
    const element = this.$el
    const priceWidth = element.querySelector('.route-price') && element.querySelector('.route-price').offsetWidth
    const allowWidth = this.width - priceWidth
    const actualWidth = this.calcFeaturesWidth(this.route.featureList)
    // if the width of actual features is larger than expect width, regenerate features
    if (allowWidth < actualWidth) {
      this.regenerateFeatures(this.features, allowWidth)
    }
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/Card/RouteCard.vue